<div class="grid-container grid-page">
  <app-activity-filter [mode]="'agent'" #activityFilter [filter]="filter" (search)="search($event)"></app-activity-filter>

  <app-activity-grid
    [mode]="'agent'"
    [filter]="filter"
    (busy)="activityFilter.disabled = $event"
    [pdfFileName]="'AgentActivity.pdf'"
    [excelFileName]="'AgentActivity.xlsx'"
    reportName="AgentActivity"
    (filterChange)="onFilterChange($event)"
  ></app-activity-grid>
</div>
